<div class="home-page">

    <app-products-categories class="child"  [currentCategory]=currentcategoryObj></app-products-categories>
</div>


// WEBPACK FOOTER //
// ./src/app/home-page/home-page.component.html